import React from "react";
import { Box } from "../../../../components";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { CPServiceObjectDetail } from "../../../../api/models/unified";

interface Props {
  serviceObjectDetail: CPServiceObjectDetail;
}

const ServiceObjectInfoBox: React.FC<Props> = (props): React.ReactElement => {
  const { serviceObjectDetail } = props;
  const { tServiceObject, t } = useCustomTranslation();

  const nextRevisionCategory = serviceObjectDetail.revisionCategories.find(
    (x) => x.id === serviceObjectDetail.nextRevisionCategoryId,
  );

  return (
    <Box
      cols={2}
      title={tServiceObject("basic_info")}
      items={[
        { label: tServiceObject("name"), value: serviceObjectDetail.name },
        {
          label: tServiceObject("category"),
          value: serviceObjectDetail.categoryName,
        },
        {
          label: tServiceObject("identification_number"),
          value: serviceObjectDetail.identificationNumber,
        },
        {
          label: tServiceObject("manufacturer"),
          value: serviceObjectDetail.manufacturerName,
        },
        {
          label: tServiceObject("address"),
          value: serviceObjectDetail.oneLinerAddress,
        },
        {
          label: tServiceObject("location"),
          value: serviceObjectDetail.location,
        },
        {
          label: tServiceObject("operator_customer"),
          value: serviceObjectDetail.customerName,
          hidden: !serviceObjectDetail.owningCustomerId,
        },
        {
          label: tServiceObject("owning_customer"),
          value: serviceObjectDetail.owningCustomerName,
          hidden: !serviceObjectDetail.owningCustomerName,
        },
        {
          label: tServiceObject("sold_date"),
          value: renderDate(serviceObjectDetail.soldDate),
        },
        {
          label: tServiceObject("installation_date"),
          value: renderDate(serviceObjectDetail.installationDate),
        },
        {
          label: tServiceObject("nearest_next_revision"),
          value: nextRevisionCategory?.nextRevision
            ? renderDate(nextRevisionCategory.nextRevision)
            : undefined,
        },
        {
          label: tServiceObject("nearest_next_revision_category"),
          value: nextRevisionCategory?.name,
        },
        {
          label: tServiceObject("warranty_till"),
          value: renderDate(serviceObjectDetail.warrantyTill),
        },
        {
          label: tServiceObject("count"),
          value: serviceObjectDetail.count.toString(),
        },
        {
          label: tServiceObject("state"),
          value: serviceObjectDetail.isActive ? t("active") : t("inactive"),
        },
        {
          label: tServiceObject("description"),
          value: serviceObjectDetail.description,
        },
      ]}
    />
  );
};

export default ServiceObjectInfoBox;
